import React from "react";

import { Typography } from "@material-ui/core";

const Typographys = props => {
	const {
		children,
		colortext,
		variant = "body1",
		className,
		fontSize,
		fontFamily = "unset",
		lineHeight = 1,
		textTransform
	} = props;

	return (
		<Typography
			{...props}
			style={{
				lineHeight: lineHeight,
				color: colortext,
				fontSize: fontSize,
				fontFamily: fontFamily,
				textTransform: textTransform ? textTransform : "none"
			}}
			className={className}
			variant={variant}
		>
			{children}
		</Typography>
	);
};

export default Typographys;
